/* unplugin-vue-components disabled */import { render, staticRenderFns } from "./GroupClassSelectForm.vue?vue&type=template&id=e629eccc&scoped=true&"
import script from "./GroupClassSelectForm.vue?vue&type=script&setup=true&lang=js&"
export * from "./GroupClassSelectForm.vue?vue&type=script&setup=true&lang=js&"
import style0 from "./GroupClassSelectForm.vue?vue&type=style&index=0&id=e629eccc&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e629eccc",
  null
  
)

export default component.exports